import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const panelEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		Record<string, never>,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/PanelEntryPointComponent" */ './PanelEntryPointComponent'
			),
		{
			moduleId: 'panel-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
